export default "__VITE_ASSET__Aa_ND_Ph__"